import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import DragAndDrop from 'modules/common/components/DragAndDrop';
import useFormValidator from 'useFormValidator';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import useUnitConverter from "modules/common/components/UseUnitConverter";
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import Select from "react-select";
import { ModalContext } from 'App';
import { Acl } from 'modules/common/components/Acl';
import { customStyle, subDays } from 'helper';
import InputMask from "react-input-mask";
import Citizenship from 'modules/CDL/individual/components/Citizenship';
import Institution from 'modules/OHP/healthPermit/components/Institution';
import * as actions from '../action';
import * as c from '../constant';

function CitizenModal({
  createUploader,
  createCitizen,
  updateCitizen,
  formData,
  setFormData,
  getTransactionList,
  type,
  showTransaction,
  id,
  history,
  updateList,
  getRegionsList,
  getProvinceList,
  getMunicipalityList,
  getBarangayList,
  regionsList,
  municipalityList,
  provinceList,
  createSelect,
  generate,
  permissions,
}) {

  const validateForm = useFormValidator(formData, {
    first_name: 'required',
    last_name: 'required',
    user_id: 'required',
    photo: 'required',
    civil_status: 'required',
    gender: 'required',
    birth_date: 'required',
    place_of_birth_region_code: 'required',
    place_of_birth_province_code: 'required',
    place_of_birth_municipality_code: 'required',
    login_pin: 'required|pin',
    height: 'required',
    weight: 'required',
  });

  const setModal = useContext(ModalContext);

  const HeightConverter = useUnitConverter("length", "ft", (data) => {
    setFormData({
      ...formData,
      height: data === "NaN" ? 0 : data,
    });
  });

  const WeightConverter = useUnitConverter("mass", "kg", (data) => {
    setFormData({
      ...formData,
      weight: data === "NaN" ? 0 : data,
    });
  });

  const [selectedIndex, setSelectedIndex] = useState(0);

  const handleNext = () => {
    if (selectedIndex === 0) {
      if (!_.isEmpty(formData.first_name) &&
        !_.isEmpty(formData.photo) &&
        !_.isEmpty(formData.last_name) &&
        !_.isEmpty(formData.civil_status) &&
        !_.isEmpty(formData.gender) &&
        !_.isEmpty(formData.birth_date) &&
        !_.isEmpty(formData.place_of_birth_region_code) &&
        !_.isEmpty(formData.place_of_birth_municipality_code) &&
        !_.isEmpty(formData.place_of_birth_province_code) &&
        !_.isEmpty(formData.user_id) &&
        !_.isEmpty(formData.login_pin)) {
        setSelectedIndex(selectedIndex + 1);
      }
      if (_.isEmpty(formData.first_name) ||
        _.isEmpty(formData.photo) ||
        _.isEmpty(formData.last_name) ||
        _.isEmpty(formData.civil_status) ||
        _.isEmpty(formData.gender) ||
        _.isEmpty(formData.birth_date) ||
        _.isEmpty(formData.place_of_birth_region_code) ||
        _.isEmpty(formData.place_of_birth_municipality_code) ||
        _.isEmpty(formData.place_of_birth_province_code ||
          _.isEmpty(formData.user_id) || _.isEmpty(formData.login_pin))) {

        Alert.error('Please fill all the required fields.');
      }
    }
    if (selectedIndex === 1 && type === "NEW") {

      if (formData.height === 0 ||
        formData.weight === 0 ||
        _.isEmpty(formData.complexion)) {
        Alert.error('Please fill all the required fields.');
      }
      if (formData.height !== 0 &&
        formData.weight !== 0 &&
        !_.isEmpty(formData.complexion)) {
        setSelectedIndex(selectedIndex + 1);
      }
    }

    if (selectedIndex === 1 && type === "EDIT") {
      if (_.isEmpty(formData.height) ||
        _.isEmpty(formData.weight) ||
        _.isEmpty(formData.complexion)) {
        Alert.error('Please fill all the required fields.');
      }
      if (!_.isEmpty(formData.height) &&
        !_.isEmpty(formData.weight) &&
        !_.isEmpty(formData.complexion)) {
        setSelectedIndex(selectedIndex + 1);
      }
    }
  };

  const handlePrev = () => {
    if (selectedIndex > 0) {
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const onChangePhoto = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data.cdnUrl,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      proof_of_residency_url: formData.proof_of_residency_url.cdnUrl,
      photo: formData.photo.cdnUrl,
    };

    if (type === "NEW") {
      createCitizen(args, ({ data }) => {
        setModal({ isOpen: false });
        getTransactionList();
        history.push(
          `/citizens/profiles/${_.get(data, 'id')}`
        );
        showTransaction(_.get(data, 'id'));
      });
    }

    if (type === "EDIT") {
      updateCitizen(id, args, ({ data }) => {
        setModal({ isOpen: false });
        getTransactionList();
        history.push(
          `/citizens/profiles/${_.get(data, 'id')}`
        );
        showTransaction(_.get(data, 'id'));
      });
    }


  };


  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'NEW') {
      const args = {
        ...c.FORM_DATA,
      }
      setFormData(args);
    }
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  const onChangeDecimal = (e) => {
    if (e.target.value && /^\d{1,}(\.\d{0,4})?$/.test(e.target.value)) {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }

    if (!e.target.value) {
      setFormData({
        ...formData,
        [e.target.name]: "",
      });
    }
  };

  const onBlurDecimal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value ? parseFloat(e.target.value) : "",
    });
  };


  const handleOnChange = (e) => {
    const is_resident = +_.get(formData, "is_resident", 0) ? 0 : 1;
    const is_voter = +_.get(formData, "is_voter", 0) ? 0 : 1;

    let newValue = e.target.value
    if (e.target.name === "is_resident") {
      newValue = is_resident
    }

    if (e.target.name === "is_voter") {
      newValue = is_voter
    }

    setFormData({
      ...formData,
      [e.target.name]: newValue,
    });
  };

  useEffect(() => {
    getRegionsList();
  }, []);

  useEffect(() => {
    getProvinceList();
  }, []);

  useEffect(() => {
    getMunicipalityList();
  }, []);

  useEffect(() => {
    getBarangayList();
  }, []);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleRegionSelect = e => {
    setFormData({
      ...formData,
      place_of_birth_region_code: e.value,
    });
    getProvinceList({ region_code: e.value });
  };

  const handleProvinceSelect = e => {
    setFormData({
      ...formData,
      place_of_birth_province_code: e.value,
    });
    getMunicipalityList({ province_code: e.value });
  };

  const handleMunicipalitySelect = e => {
    setFormData({
      ...formData,
      place_of_birth_municipality_code: e.value,
    });
    getBarangayList({ municipality_code: e.value });
  };

  const handleOnChangeSelect = name => data => {
    setFormData({
      ...formData,
      [name]: data.value,
    });
  };

  const generateUsername = (e) => {
    e.preventDefault();
    generate({ first_name: formData.first_name, last_name: formData.last_name }, (finalData) => {
      setFormData({
        ...formData,
        user_id: finalData,
      })
    });
  };

  const getSelectedOptions = (list, value) => {
    return createDropdown(list).find(x => x.value === value) || {};
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        {selectedIndex === 0
          && (
            <>
              <div className="row d-flex justify-content-center text-primary">
                Personal Information
              </div>
              <div className="row">
                <div className="col-md-3">
                  <div className="full-group ">
                    <div className="row d-flex justify-content-center">
                      <div className="col-12">
                        <img
                          className="w-100 rounded"
                          src={
                            !_.isObject(_.get(formData, 'photo') || '')
                              ? _.get(formData, 'photo') || ImagePlaceholder
                              : _.get(formData, 'photo.cdnUrl') || ImagePlaceholder
                          }
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                      <div className="col-12 form-group">
                        {createUploader(
                          { key: 'photo', label: 'Browse' },
                          { required: true }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9 row">
                  <div className="col-4 form-group">
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      First Name{" "}
                      {validateForm.renderMessage(
                        "first_name"
                      )}
                    </label>
                    <input
                      required
                      className='form-control'
                      type='text'
                      name='first_name'
                      id='first_name'
                      onChange={handleOnChange}
                      value={
                        _.get(formData, "first_name") ||
                        ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className="col-4 form-group">
                    <label
                      htmlFor='middle_name'
                      className='form-label mb-0'
                    >
                      Middle Name{" "}
                    </label>
                    <input
                      required
                      className='form-control'
                      type='text'
                      name='middle_name'
                      id='middle_name'
                      onChange={handleOnChange}
                      value={
                        _.get(formData, "middle_name") ||
                        ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className="col-4 form-group">
                    <label
                      htmlFor='last_name'
                      className='form-label mb-0'
                    >
                      Last Name{" "}
                      {validateForm.renderMessage(
                        "last_name"
                      )}
                    </label>
                    <input
                      required
                      className='form-control'
                      type='text'
                      name='last_name'
                      id='last_name'
                      onChange={handleOnChange}
                      value={
                        _.get(formData, "last_name") ||
                        ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className="col-4 form-group">
                    {createSelect(
                      {
                        required: true,
                        placeholder: 'Extension Name',
                        key: 'extension_name',
                        label: 'Extension Name',
                      },
                      c.EXTENSION_NAMES
                    )}
                  </div>
                  <div className="col-4 form-group">
                    <label className="form-label">
                      Civil Status
                      {validateForm.renderMessage('civil_status')}
                    </label>
                    <Select
                      styles={customStyle}
                      value={
                        c.CIVIL_STATUSES.find(
                          item =>
                            _.get(formData, 'civil_status') === _.get(item, 'value')
                        ) || ''
                      }
                      onChange={handleOnChangeSelect('civil_status')}
                      options={c.CIVIL_STATUSES}
                    />
                  </div>
                  <div className="col-4 form-group">
                    <label htmlFor="gender" className="form-label">
                      Gender
                      {validateForm.renderMessage('gender')}
                    </label>
                    <Select
                      styles={customStyle}
                      value={
                        c.GENDERS.find(
                          item => _.get(formData, 'gender') === _.get(item, 'value')
                        ) || ''
                      }
                      onChange={handleOnChangeSelect('gender')}
                      options={c.GENDERS}
                    />
                  </div>
                  <div className="col-4 form-group">
                    <label className="form-control-plaintext form-label">
                      Birthdate:{' '}
                      {validateForm.renderMessage('birth_date')}
                    </label>
                    <DateInputPicker
                      className="form-control"
                      onChange={handleOnChangeDate('birth_date')}
                      value={_.get(formData, 'birth_date') || ''}
                      maxDate={subDays(1)}
                    />
                  </div>
                </div>
              </div>

              <hr />
              <div className="row d-flex justify-content-center text-primary">
                Place of Birth
              </div>
              <div className="row">
                <div className="col-4 form-group">
                  <label className="form-label">
                    Region:
                    {validateForm.renderMessage('place_of_birth_region_code')}
                  </label>
                  <Select
                    styles={customStyle}
                    placeholder="Select Region"
                    value={getSelectedOptions(regionsList, formData.place_of_birth_region_code)}
                    options={createDropdown(regionsList)}
                    onChange={e => {
                      handleRegionSelect(e);
                    }}
                  />
                </div>
                <div className="col-4 form-group">
                  <label className="form-label">
                    Province:
                    {validateForm.renderMessage('place_of_birth_province_code')}
                  </label>
                  <Select
                    value={getSelectedOptions(
                      provinceList,
                      formData.place_of_birth_province_code
                    )}
                    styles={customStyle}
                    placeholder="Select Province"
                    options={createDropdown(provinceList)}
                    onChange={e => {
                      handleProvinceSelect(e);
                    }}
                  />
                </div>
                <div className="col-4 form-group">
                  <label className="form-label">
                    Municipality:
                    {validateForm.renderMessage('place_of_birth_municipality_code')}
                  </label>
                  <Select
                    options={createDropdown(municipalityList)}
                    styles={customStyle}
                    placeholder="Select Municipality"
                    value={getSelectedOptions(
                      municipalityList,
                      formData.place_of_birth_municipality_code
                    )}
                    onChange={e => {
                      handleMunicipalitySelect(e);
                    }}
                  />
                </div>
                <div className="col-6 form-group">
                  <div className='form-check col-12 col-md-4'>
                    <label
                      htmlFor='name'
                      className='form-label mb-0 pr-5'
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#74767b"
                      }}
                    >
                      Resident
                    </label>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={_.get(
                        formData,
                        "is_resident"
                      )}
                      name='is_resident'
                      id='is_resident'
                      onChange={handleOnChange}
                    />
                    <label
                      className='form-check-label'
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#4C6085",
                      }}
                    >
                      Yes
                    </label>
                  </div>
                </div>
                <div className="col-6 form-group">
                  <div className='form-check col-12 col-md-4'>
                    <label
                      htmlFor='name'
                      className='form-label mb-0 pr-5'
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#74767b",
                      }}
                    >
                      Voter
                    </label>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={_.get(
                        formData,
                        "is_voter"
                      )}
                      name='is_voter'
                      id='is_voter'
                      onChange={handleOnChange}
                    />
                    <label
                      className='form-check-label'
                      style={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        color: "#4C6085",
                      }}
                    >
                      Yes
                    </label>
                  </div>
                </div>
              </div>
              <hr />
              {Acl(permissions, ['GENERATE USERNAME AND PIN']) && (
                <>
                  <div className="row">
                    <div className="col-4 form-group">
                      <button
                        disabled={_.isEmpty(formData.first_name) || _.isEmpty(formData.last_name)}
                        type="button"
                        onClick={generateUsername}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  button-generate"
                      >
                        <span className="font-weight-bold">
                          Generate
                        </span>
                      </button>
                    </div>
                    <div className="col-4 form-group">
                      <label className="form-label mb-0">
                        Username: {validateForm.renderMessage('user_id')}
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="user_id"
                        value={_.get(formData, 'user_id') || ''}
                        disabled
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-4 form-group">
                      <label className="form-label mb-0">
                        Pin: {validateForm.renderMessage('login_pin')}
                      </label>
                      <InputMask
                        placeholder='----'
                        className='form-control'
                        maskChar=' '
                        mask='9999'
                        autoComplete='none'
                        id='login_pin'
                        name='login_pin'
                        onChange={handleOnChange}
                        value={
                          _.get(formData, "login_pin") ||
                          ""
                        }
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-12 form-group">
                <label className="font- -bold">Upload Proof of Residency:</label>
                <div className="row d-flex">
                  <div className='col-12 col-md-8'>
                    <div className='form-wrapper arrow-card p-4'>
                      {!_.get(formData, 'proof_of_residency_url')
                        ? (
                          <DragAndDrop
                            onChange={onChangePhoto('proof_of_residency_url')}
                            maxSize={2}
                            caption="JPEG. PNG. Maximum size 2MB."
                            label="Upload your Requirements here"
                            fileType="image/jpeg, image/jpg, image/png"
                          />
                        ) : (
                          <div className='bg-dark text-center py-2 pb-5 rounded'>
                            <div className='d-flex justify-content-end col-1'>
                              {createUploader(
                                { key: 'proof_of_residency_url', label: 'Proof of Residency' },
                                { placeholder: '  ' }
                              )}
                            </div>
                            <img
                              src={
                                !_.isObject(_.get(formData, 'proof_of_residency_url') || '')
                                  ? (_.get(formData, 'proof_of_residency_url') || ImagePlaceholder)
                                  : (_.get(formData, 'proof_of_residency_url.cdnUrl') || ImagePlaceholder)
                              }
                              className='img-fluid shadow-lg'
                              role='presentation'
                              width='70%'
                              alt=""
                            />
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="text-center mt-4">
                <button
                  onClick={handleNext}
                  type="button"
                  className="btn btn-proceed cms-bg-color-primary"
                >
                  Proceed
                </button>
              </div>
            </>
          )
        }
        {selectedIndex === 1
          && (
            <>
              <div className="row d-flex justify-content-center text-primary">
                Identity Information
              </div>
              <div className='full-group'>
                <div className='form-row'>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='middle_name'
                      className='form-label mb-0 d-flex'
                    >
                      Height{" "}(in ft)
                      {validateForm.renderMessage(
                        "height"
                      )}
                      <HeightConverter />
                    </label>
                    <input
                      placeholder='0.00'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='height'
                      id='height'
                      onChange={onChangeDecimal}
                      onBlur={onBlurDecimal}
                      value={
                        _.get(formData, "height") || ""
                      }
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0 d-flex'
                    >
                      Weight{" "}(in kg)
                      {validateForm.renderMessage(
                        "weight"
                      )}
                      <WeightConverter />
                    </label>
                    <input
                      placeholder='0.00'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='weight'
                      id='weight'
                      onChange={onChangeDecimal}
                      onBlur={onBlurDecimal}
                      value={
                        _.get(formData, "weight") || ""
                      }
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4 '>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      Complexion
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='complexion'
                      id='complexion'
                      onChange={handleOnChange}
                      value={
                        _.get(formData, "complexion") ||
                        ""
                      }
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='last_name'
                      className='form-label mb-0'
                    >
                      Country of Citizenship
                    </label>
                    <Citizenship
                      value={
                        _.get(
                          formData,
                          "citizenship_code"
                        ) || "PHL"
                      }
                      name='citizenship_code'
                      onChange={handleOnChange}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center mt-4">
                <button
                  onClick={handlePrev}
                  type="button"
                  className="btn btn-previous cms-bg-color-primary"
                >
                  Previous
                </button>
                <button
                  onClick={handleNext}
                  type="button"
                  className=" ml-2 btn btn-proceed cms-bg-color-primary"
                >
                  Proceed
                </button>
              </div>
            </>
          )
        }
        {selectedIndex === 2
          && (
            <>
              <div className="row d-flex justify-content-center text-primary">
                Educational Information
              </div>
              <div className='full-group'>
                <div className='form-row'>
                  <div className='form-input-group col-12 col-md-6 '>
                    {createSelect(
                      {
                        key: 'highest_educational_attainment',
                        label: 'Highest Educational Attainment:',
                      },
                      c.HIGHEST_EDUCATIONAL_ATTAINMENT
                    )}
                  </div>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='middle_name'
                      className='form-label mb-0'
                    >
                      Institution
                    </label>
                    <Institution
                      name='institution_code'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "institution_code"
                        ) || ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="text-center mt-4">
                <button
                  onClick={handlePrev}
                  type="button"
                  className="btn btn-previous cms-bg-color-primary"
                >
                  Previous
                </button>
                <button
                  onClick={handleNext}
                  type="button"
                  className=" ml-2 btn btn-proceed cms-bg-color-primary"
                >
                  Proceed
                </button>
              </div>
            </>
          )
        }
        {
          selectedIndex === 3
          && (
            <>
              <div className="row d-flex justify-content-center text-primary">
                Government Information
              </div>
              <div className='full-group'>
                <div className='form-row'>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      Tax Identification Number (TIN)
                    </label>
                    <InputMask
                      placeholder='---_---_---_-----'
                      className='form-control'
                      maskChar=' '
                      mask='999-999-999-99999'
                      autoComplete='none'
                      id='tin_number'
                      name='tin_number'
                      onChange={handleOnChange}
                      value={
                        _.get(formData, "tin_number") ||
                        ""
                      }
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      PAG-IBIG Number{" "}
                    </label>
                    <InputMask
                      placeholder='----_----_----'
                      className='form-control'
                      maskChar=' '
                      mask='9999-9999-9999'
                      autoComplete='none'
                      id='pagibig_id_number'
                      name='pagibig_id_number'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "pagibig_id_number"
                        ) || ""
                      }
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      PHILHEALTH Number
                    </label>
                    <InputMask
                      placeholder='__-_________-_'
                      className='form-control'
                      maskChar=' '
                      mask='99-999999999-9'
                      autoComplete='none'
                      id='philhealth_id_number'
                      name='philhealth_id_number'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "philhealth_id_number"
                        ) || ""
                      }
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      UMID/SSS Number
                    </label>
                    <InputMask
                      placeholder='----_-------_-'
                      className='form-control'
                      maskChar=' '
                      mask='9999-9999999-9'
                      autoComplete='none'
                      id='sss_id_number'
                      name='sss_id_number'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "sss_id_number"
                        ) || ""
                      }
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-6'>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      GSIS ID Number{" "}
                    </label>
                    <InputMask
                      placeholder='---_---_---_-----'
                      className='form-control'
                      maskChar=' '
                      autoComplete='none'
                      id='gsis_id_number'
                      name='gsis_id_number'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "gsis_id_number"
                        ) || ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="text-center mt-4">
                <button
                  onClick={handlePrev}
                  type="button"
                  className="btn btn-previous cms-bg-color-primary"
                >
                  Previous
                </button>
                <button
                  onClick={handleNext}
                  type="button"
                  className=" ml-2 btn btn-proceed cms-bg-color-primary"
                >
                  Proceed
                </button>
              </div>
            </>
          )
        }
        {
          selectedIndex === 4
          && (
            <>
              <div className="row d-flex justify-content-center text-primary">
                Family Information
              </div>
              <div className='full-group '>
                <label
                  htmlFor='business_address'
                  className='form-label mb-0 text-success'
                >
                  Mother&apos;s Maiden Name
                </label>
                <div className='form-row'>
                  <div className='form-input-group col-12 col-md-4   '>
                    <label
                      htmlFor='last_name'
                      className='form-label mb-0'
                    >
                      Last Name{" "}
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='mother_maiden_last_name'
                      id='mother_maiden_last_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "mother_maiden_last_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4   '>
                    <label
                      htmlFor='middle_name'
                      className='form-label mb-0'
                    >
                      Middle Name
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='mother_maiden_middle_name'
                      id='mother_maiden_middle_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "mother_maiden_middle_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4 '>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      First Name{" "}
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='mother_maiden_first_name'
                      id='mother_maiden_first_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "mother_maiden_first_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                </div>
              </div>
              <div className='full-group '>
                <label
                  htmlFor='business_address'
                  className='form-label mb-0 text-success'
                >
                  Father&apos;s Name
                </label>
                <div className='form-row'>
                  <div className='form-input-group col-12 col-md-4'>
                    <label
                      htmlFor='last_name'
                      className='form-label mb-0'
                    >
                      Last Name
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='father_last_name'
                      id='father_last_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "father_last_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4   '>
                    <label
                      htmlFor='middle_name'
                      className='form-label mb-0'
                    >
                      Middle Name
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='father_middle_name'
                      id='father_middle_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "father_middle_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4 '>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      First Name
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='father_first_name'
                      id='father_first_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "father_first_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                </div>
              </div>
              <div className='full-group '>
                <label
                  htmlFor='business_address'
                  className='form-label mb-0 text-success'
                >
                  Spouse Name
                </label>
                <div className='form-row'>
                  <div className='form-input-group col-12 col-md-4'>
                    <label
                      htmlFor='last_name'
                      className='form-label mb-0'
                    >
                      Last Name{" "}
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='spouse_last_name'
                      id='spouse_last_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "spouse_last_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4'>
                    <label
                      htmlFor='middle_name'
                      className='form-label mb-0'
                    >
                      Middle Name
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='spouse_middle_name'
                      id='spouse_middle_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "spouse_middle_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4 '>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      First Name{" "}
                    </label>
                    <input
                      placeholder='_'
                      className='form-control text-uppercase'
                      type='text'
                      autoComplete='none'
                      name='spouse_first_name'
                      id='spouse_first_name'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "spouse_first_name"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                  <div className='form-input-group col-12 col-md-4 '>
                    <label
                      htmlFor='first_name'
                      className='form-label mb-0'
                    >
                      Mobile Number{" "}
                    </label>
                    <InputMask
                      className='form-control'
                      type='text'
                      maskChar={null}
                      placeholder='09000000000'
                      mask='99999999999'
                      id='spouse_mobile_number'
                      autoComplete='none'
                      name='spouse_mobile_number'
                      onChange={handleOnChange}
                      value={
                        _.get(
                          formData,
                          "spouse_mobile_number"
                        ) || ""
                      }
                      style={{ textTransform: 'uppercase' }}
                    />
                  </div>
                </div>
              </div>
              <div className="text-center mt-4">
                <button
                  onClick={handlePrev}
                  type="button"
                  className="btn btn-previous cms-bg-color-primary"
                >
                  Previous
                </button>
                <button
                  type="submit"
                  className=" ml-2 btn btn-proceed cms-bg-color-primary"
                >
                  Save
                </button>
              </div>
            </>
          )
        }
      </form>
    </Modal.Body>
  );
};

CitizenModal.defaultProps = {
  type: '',
  id: '',
  updateList: {},
};

CitizenModal.propTypes = {
  createUploader: PropTypes.instanceOf(Function).isRequired,
  createCitizen: PropTypes.instanceOf(Function).isRequired,
  updateCitizen: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object),

  type: PropTypes.string,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  generate: PropTypes.instanceOf(Function).isRequired,
  getRegionsList: PropTypes.instanceOf(Function).isRequired,
  getProvinceList: PropTypes.instanceOf(Function).isRequired,
  getMunicipalityList: PropTypes.instanceOf(Function).isRequired,
  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  regionsList: PropTypes.instanceOf(Array).isRequired,
  provinceList: PropTypes.instanceOf(Array).isRequired,
  municipalityList: PropTypes.instanceOf(Array).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  regionsList: _.get(api, `${c.GET_REGION}.list`) || [],
  provinceList: _.get(api, `${c.GET_PROVINCE}.list`) || [],
  municipalityList: _.get(api, `${c.GET_MUNICIPALITIES}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CitizenModal);
